// Module
var code = "<template> <div ref=\"viewportRef\" style=\"flex:1 1 auto;display:flex;overflow:hidden\"> <canvas ref=\"canvasRef\" click.delegate=\"click()\" style=\"flex:1 1 auto\"></canvas> </div> </template> ";
// Exports
export default code;